/**
 * Marketplace Health Service
 * Handles marketplace health report data fetching
 */

import { IS_MOCK, MOCK_DELAY } from '../../constants/config';
import { generateMockMarketplaceHealthData } from '../mock/mockMarketplaceHealth';
import { delay } from '../mock/mockData';
import type { MarketplaceHealthData, ReportFilters } from '../../types/reports';

class MarketplaceHealthService {
  /**
   * Get marketplace health report data
   */
  static async getMarketplaceHealthData(
    filters?: ReportFilters
  ): Promise<MarketplaceHealthData> {
    if (IS_MOCK) {
      await delay(MOCK_DELAY / 2);
      return generateMockMarketplaceHealthData();
    } else {
      const params = new URLSearchParams();
      
      if (filters?.dateRange) params.append('dateRange', filters.dateRange);
      if (filters?.region) params.append('region', filters.region);
      
      const response = await fetch(`/api/reports/marketplace-health?${params.toString()}`);
      if (!response.ok) {
        throw new Error('Failed to fetch marketplace health data');
      }
      return response.json();
    }
  }
}

export { MarketplaceHealthService };

